var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"custom-scroll overflow-auto",staticStyle:{"height":"calc(100vh - 213px)"}},[_c('mapa-google',{ref:"GoogleMaps",attrs:{"desactivar-mapa":false,"icono-central":"/img/icons/tendero-point-map.svg","dragable":false,"height":"100%","width":"100%"},on:{"actualizar":_vm.getDatos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }